var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-button',{staticClass:"buttons btn-accent",on:{"click":function($event){return _vm.openModal()}}},[_vm._v(" Aprovar orçamento ")])
}
var staticRenderFns = []

export { render, staticRenderFns }